<template>
  <div :class="classes">
    <div :class="headClasses" v-if="showHead" :style="headerStyle">
      <slot name="title">
        <p v-if="title">
          <!--<Icon v-if="icon" :type="icon"></Icon>-->
          <span>{{title}}</span>
        </p>
      </slot>
    </div>
    <div :class="extraClasses" v-if="showExtra"><slot name="extra"></slot></div>
    <div :class="bodyClasses" :style="bodyStyles"><slot></slot></div>
  </div>
</template>

<script>
  const prefixCls = 'am-card';
  const defaultPadding = 16;
  // import Icon from '@/components/icon/index.vue';
    export default {
        name: 'Card',
        props: {
          bordered: {
            type: Boolean,
            default: true
          },
          disHover: {
            type: Boolean,
            default: false
          },
          shadow: {
            type: Boolean,
            default: false
          },
          padding: {
            type: Number,
            default: defaultPadding
          },
          title: {
            type: String,
          },
          icon: {
            type: String,
          },
          headerStyle: {
            type: Object,
            default () {
              return {}
            }
          },
          bodyStyle: {
            type: Object,
            default () {
              return {}
            }
          }
        },
        created() {
        },
        data() {
            return {
              showHead: true,
              showExtra: true
            }
        },
        mounted() {
          this.showHead = this.title || this.$slots.title !== undefined;
          this.showExtra = this.$slots.extra !== undefined;
        },
        computed: {
          classes () {
            return [
              `${prefixCls}`,
              {
                [`${prefixCls}-bordered`]: this.bordered && !this.shadow,
                [`${prefixCls}-dis-hover`]: this.disHover || this.shadow,
                [`${prefixCls}-shadow`]: this.shadow
              }
            ];
          },
          headClasses () {
            return `${prefixCls}-head`;
          },
          extraClasses () {
            return `${prefixCls}-extra`;
          },
          bodyClasses () {
            return `${prefixCls}-body`;
          },
          bodyStyles () {
            let o = {...this.bodyStyle}
            if (this.padding !== defaultPadding) {
              o.padding = `${this.padding}px`
            }
            return o
          }
        },
        methods: {},
        components: {
          // Icon
        }
    }
</script>

<style lang="less">
  @css-prefix: 'am-';
  @card-prefix-cls: ~"@{css-prefix}card";
  @border-radius-small    : 4px;
  @font-size-base         : 14px;
  // Animation
  @transition-time        : .2s;
  @ease-in-out            : ease-in-out;
  // Border color
  @border-color-base      : #dcdee2;  // outside
  @border-color-split     : #e8eaec;  // inside
  // Shadow
  @shadow-color           : rgba(0, 0, 0, .2);
  @shadow-base            : @shadow-down;
  @shadow-card            : 0 1px 1px 0 rgba(0,0,0,.1);
  @shadow-up              : 0 -1px 6px @shadow-color;
  @shadow-down            : 0 1px 6px @shadow-color;
  @shadow-left            : -1px 0 6px @shadow-color;
  @shadow-right           : 1px 0 6px @shadow-color;
  .@{card-prefix-cls}{
    border-radius: @border-radius-small;
    font-size: @font-size-base;
    position: relative;
    //overflow: hidden;
    transition: all @transition-time @ease-in-out;

    &-bordered {
      border: 1px solid @border-color-base;
      border-color: @border-color-split;
    }

    &-shadow{
      box-shadow: @shadow-card;
    }

    &:hover {
      box-shadow: @shadow-base;
      border-color: #eee;
    }
    &&-dis-hover:hover{
      box-shadow: none;
      border-color: transparent;
    }

    &&-dis-hover&-bordered:hover{
      border-color: @border-color-split;
    }

    &&-shadow:hover{
      box-shadow: @shadow-card;
    }

    &-head {
      border-bottom: 1px solid #e8eaec;
      padding: 14px 16px;
      line-height: 1;
    }

    &-extra {
      position: absolute;
      right: 16px;
      top: 14px;
    }

    &-body {
      padding: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Card/Card.vue